module.exports = __webpack_public_path__ + "img/select2_arrow_bottom.8ef65715.svg";